import { makeStyles } from "@mui/styles";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  TableCell,
  Tooltip,
} from "@mui/material";
import {
  Cancel,
  Check,
  Create,
  Delete,
  ExpandLess,
  ExpandMore,
  PictureAsPdf,
} from "@mui/icons-material";
import React, { memo, useContext, useState } from "react";
import { withRouter } from "react-router";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../../Context/Auth/AuthContext";
import MenuContext from "../../../../Context/Menu/MenuContext";
import { permisoDenagado, serverphp } from "../../../../config/const";
import { tienePermisoRuta } from "../../../../config/validaciones";
import { ListRounded } from "@mui/icons-material";
import ButtonsActionsDialog from "./ButtonsActionsDialog";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const ButtonsAction = (props) => {
  const {
    arrayExport,
    setarrayExport,
    campoExport,
    row,
    setopenConfirmDialog,
    funcionEdit,
    ocultarEditar,
    ocultarDelete,
    mostrarEstado,
    campoEstado,
    editar,
    funcCancel,
    funcSubmit,
    botonDisabled,
    item,
    setitem,
    expandible,
    expandir,
    setexpandir,
  } = props;
  const classes = useRowStyles();
  const { usuario } = useContext(AuthContext);
  const { rows } = useContext(MenuContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  const [open, setopen] = useState(false);
 
  return (
    <>
      {" "}
      <ButtonsActionsDialog
        open={open}
        setopen={setopen}
        setopenConfirmDialog={setopenConfirmDialog}
        row={row}
        // setopenModalEmail={setopenModalEmail}
      />
      {arrayExport ? (
        <TableCell
          size="small"
          padding="checkbox"
          style={{
            borderRight: "1px solid #ccc",
            maxWidth: "1rem",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <FormControlLabel
              className={classes.margin}
              control={
                <Checkbox
                  size="small"
                  className={classes.margin}
                  checked={arrayExport.some((item) => {
                    return item[campoExport] === row[campoExport];
                  })}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setarrayExport([...arrayExport, row]);
                    } else {
                      setarrayExport(
                        arrayExport.filter(
                          (item) => item[campoExport] !== row[campoExport]
                        )
                      );
                    }
                  }}
                  color="secondary"
                />
              }
            />
          </Box>
        </TableCell>
      ) : null}
      <TableCell padding="none" style={{ borderRight: "1px solid #ccc" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-around"
          ml={1}
          mr={1}
        >
          <Tooltip title="Mas acciones" arrow>
            <IconButton
              className={classes.margin}
              onClick={() => {
                setopen(true);
              }}
            >
              <ListRounded />
            </IconButton>
          </Tooltip>
          <>
            {editar ? (
              <>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    funcCancel();
                  }}
                >
                  <Cancel fontSize="small" color="secondary" />
                </IconButton>
                <IconButton
                  className={classes.margin}
                  disabled={botonDisabled ? botonDisabled() : false}
                  onClick={() => {
                    funcSubmit();
                  }}
                >
                  <Check
                    fontSize="small"
                    color={
                      botonDisabled
                        ? botonDisabled()
                          ? "inherit"
                          : "secondary"
                        : "secondary"
                    }
                  />
                </IconButton>
              </>
            ) : (
              <>
                {" "}
                {ocultarDelete ? null : (
                  <IconButton
                    className={classes.margin}
                    onClick={() => {
                      if (
                        !tienePermisoRuta(
                          rows,
                          props.location.pathname,
                          usuario.rol,
                          "eliminar"
                        )
                      ) {
                        return mostrarAlerta(permisoDenagado, "error");
                      }
                      setopenConfirmDialog(true);
                    }}
                  >
                    <Delete fontSize="small" color="error" />
                  </IconButton>
                )}
                {ocultarEditar ? null : (
                  <IconButton
                    className={classes.margin}
                    onClick={() => {
                      if (
                        !tienePermisoRuta(
                          rows,
                          props.location.pathname,
                          usuario.rol,
                          "editar"
                        )
                      ) {
                        return mostrarAlerta(permisoDenagado, "error");
                      }
                      funcionEdit();
                    }}
                  >
                    <Create color="secondary" />
                  </IconButton>
                )}
              </>
            )}
          </>

          <Tooltip title="PDF" arrow>
            <IconButton
              className={classes.margin}
              onClick={() => {
                // Abres la nueva ventas
                window.open(
                  `${serverphp}reportes/factura.php?codigo=${row.ventaId}&empresa=${usuario.rucempresa}`,
                  "_blank"
                );
              }}
            >
              <PictureAsPdf color="error" />
            </IconButton>
          </Tooltip>
          {expandible ? (
            expandir ? (
              <IconButton
                className={classes.margin}
                onClick={() => {
                  setexpandir(false);
                }}
              >
                <ExpandLess fontSize="small" color="secondary" />
              </IconButton>
            ) : (
              <IconButton
                className={classes.margin}
                onClick={() => {
                  setexpandir(true);
                }}
              >
                <ExpandMore fontSize="small" color="secondary" />
              </IconButton>
            )
          ) : null}
          {mostrarEstado ? (
            <Tooltip title="Correo" arrow>
              <FormControlLabel
                className={classes.margin}
                onChange={(e) => {
                  setitem({
                    ...item,
                    [campoEstado]: e.target.checked ? true : false,
                  });
                }}
                control={
                  <Checkbox
                    className={classes.margin}
                    checked={item[campoEstado]}
                    color="secondary"
                  />
                }
              />
            </Tooltip>
          ) : null}
        </Box>
      </TableCell>
    </>
  );
};

export default withRouter(memo(ButtonsAction));
